import { render, staticRenderFns } from "./Appeal.vue?vue&type=template&id=31ac498b&scoped=true"
import script from "./Appeal.vue?vue&type=script&lang=js"
export * from "./Appeal.vue?vue&type=script&lang=js"
import style0 from "./Appeal.vue?vue&type=style&index=0&id=31ac498b&prod&lang=scss&scoped=true"
import style1 from "./Appeal.vue?vue&type=style&index=1&id=31ac498b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ac498b",
  null
  
)

export default component.exports